import React, { useState, useEffect, useRef } from "react";
import Header from "./Header";

import Sidebar from "./Sidebar";
import DashboardPage from "./DashboardPage";
import ProfileContainer from "./ProfileContainer";
import AddCandidatePage from "./AddCandidatePage";
import PendingSubmissionPage from "./PendingSubmissionPage";
import LoginExpiredCandidatesPage from "./LoginExpiredCandidatesPage";
import PendingCaseSubmissionPage from "./PendingCaseSubmissionPage";
import ReadyForBgcPage from "./ReadyForBgcPage";
import SubmittedVerificationPage from "./SubmittedVerificationPage";
import BgvInProgressCandidatesPage from "./BgvInProgressCandidatesPage";
import BgvCompletedCandidatesPage from "./BgvCompletedCandidatesPage";
import TotalCandidatesPage from "./TotalCandidatesPage";
import TopNavbar from "../top-navbar/TopNav";
import ReportPage from "./Report";
import FinalReportPage from "./FinalReport";
import { sidebarItems } from "./constants";
import { FaBars, FaTimes } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import RequestManagementPage from "./RequestManagementPage";



import {
  markAllNotificationsAsRead,
  approveRequest,
  rejectRequest,
  fetchUserDashboardData,
  fetchNotifications,
  fetchUnreadCount,
} from "../../services/user/api";
// import PaymentPage from "./PaymentPage/PaymentPage";
// import PaymentSuccess from "./PaymentSuccess/PaymentSuccess";
// import PaymentFailed from "./PaymentFailed/PaymentFailed";
import { FaWallet } from "react-icons/fa";
import TransactionHistory from "../Payment/TransactionHistory/TransactionHistory";
import ClientWallet from "../Payment/ClientWallet/ClientWallet";
import "../../styles/user/clientdashboard.css";
import logo from "../../assets/images/Logo.png";
import ClientNotification from "../Notification/ClientNotification";

const ClientDashboard = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [activeMenuItem, setActiveMenuItem] = useState("Dashboard");
  const [openSubMenu, setOpenSubMenu] = useState(null);

  // const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 1024);

  const [candidateData, setCandidateData] = useState({
    fullname: "",
    email: "",
    dateOfBirth: "",
    mobileNumber: "",
  });

  const [submissionStatus, setSubmissionStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [redirectTimeout, setRedirectTimeout] = useState(null);
  const [totalCandidates, setTotalCandidates] = useState([]);
  const [fetchError, setFetchError] = useState(null);

  const [loginExpiredCandidates, setLoginExpiredCandidates] = useState([]);
  const [loginExpiredFetchError, setLoginExpiredFetchError] = useState(null);
  const [isLoadingLoginExpired, setIsLoadingLoginExpired] = useState(false);

  const [bgvInProgressCandidates, setBgvInProgressCandidates] = useState([]);
  const [bgvInProgressFetchError, setBgvInProgressFetchError] = useState(null);
  const [isLoadingBgvInProgress, setIsLoadingBgvInProgress] = useState(false);

  // New state for ReportPage
  const [showReportPage, setShowReportPage] = useState(false);
  const [reportCandidateId, setReportCandidateId] = useState(null);

  const [showFinalReportPage, setShowFinalReportPage] = useState(false);
  const [finalReportCandidateId, setFinalReportCandidateId] = useState(null);
  const toggleDropdown = () => setShowDropdown(!showDropdown);
  const [previousMenuItem, setPreviousMenuItem] = useState(null);
  const location = useLocation();
  const { candidateId } = useParams();
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  // const handleMenuClick = (menuItem) => {
  //   setActiveMenuItem(menuItem);
  //   setOpenSubMenu((prev) => (prev === menuItem ? null : menuItem));
  //   setShowReportPage(false);
  //   setReportCandidateId(null);
  // };
  const handleMenuClick = (menuItem) => {
  setActiveMenuItem(menuItem);

  setOpenSubMenu((prev) =>
    prev === menuItem ? null : menuItem,
  );

  setShowReportPage(false);
  setReportCandidateId(null);

  setShowFinalReportPage(false);
  setFinalReportCandidateId(null);
};

  const handleCandidateChange = (e) => {
    const { name, value } = e.target;
    setCandidateData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancelAddCandidate = () => {
    if (redirectTimeout) {
      clearTimeout(redirectTimeout);
      setRedirectTimeout(null);
    }
    setCandidateData({
      fullname: "",
      email: "",
      dateOfBirth: "",
      mobileNumber: "",
    });
    setSubmissionStatus(null);
    setErrorMessage("");
    setActiveMenuItem("Dashboard");
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const handleViewDetails = (uniqueId) => {
    navigate(`/candidate-details/${uniqueId}`, {
      state: {
        heading: "Candidate Report",
        candidate: uniqueId,
      },
    });
    // navigate(`/employee/candidatereportpage/${uniqueId}`);
  };

  const handleShowReportPage = (candidateId) => {
    setPreviousMenuItem(activeMenuItem);
    setActiveMenuItem("Report");
    //setShowReportPage(true);
    handleViewDetails(candidateId);
    setReportCandidateId(candidateId);
  };

  const handleBackFromReport = () => {
    setShowReportPage(false);
    setReportCandidateId(null);

    setActiveMenuItem(previousMenuItem || "Dashboard");
  };

  const handleShowFinalReportPage = (candidateId) => {
    setPreviousMenuItem(activeMenuItem);
    setActiveMenuItem("Final Report");
    setShowFinalReportPage(true);
    setFinalReportCandidateId(candidateId);
    setShowReportPage(false);
  };

  const handleBackFromFinalReport = () => {
    setShowFinalReportPage(false);
    setFinalReportCandidateId(null);
    setActiveMenuItem(previousMenuItem || "Dashboard");
  };

  const mainContentRef = useRef(null);

  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/client/finalreport/")) {
      setActiveMenuItem("Final Report");
      setShowFinalReportPage(true);
    } else if (path.includes("/profile")) {
      setActiveMenuItem("Profile");
    } else if (path.includes("/add-candidate")) {
      setActiveMenuItem("Add Candidate");
       } else if (path.includes("/approve-deny-requests")) {
    setActiveMenuItem("Approve/Deny Requests");
    setShowReportPage(false);
    setShowFinalReportPage(false);
    } else if (path.includes("/pending-submission")) {
      setActiveMenuItem("Pending Submission");
    } else if (path.includes("/login-expired")) {
      setActiveMenuItem("Login Expired Candidates");
    } else if (path.includes("/case/pending")) {
      setActiveMenuItem("Pending Case Submission");
    } else if (path.includes("/case/ready")) {
      setActiveMenuItem("Ready for BGC");
    } else if (path.includes("/case/submitted")) {
      setActiveMenuItem("Submitted Verification");
    } else if (path.includes("/case/in-progress")) {
      setActiveMenuItem("BGV In Progress Candidates");
    } else if (path.includes("/case/completed")) {
      setActiveMenuItem("BGV Completed Candidates");
    } else if (path.includes("/case/total")) {
       setActiveMenuItem("Total Candidates");
    }
    
    
    // else if (path.includes("/payment-success")) {
    //   setActiveMenuItem("PaymentSuccess");
    // } else if (path.includes("/payment-failed")) {
    //   setActiveMenuItem("PaymentFailed");
    // } else if (path.includes("/payment")) {
    //   setActiveMenuItem("Payment");
    // } else if (path.includes("/client-wallet")) {
    //   setActiveMenuItem("Client Wallet");
    // } else if (path.includes("/transaction-history")) {
    //   setActiveMenuItem("Transaction History");
    // }
    
    
    else if (path.includes("/dashboard")) {
  setActiveMenuItem("Dashboard");
}

  }, [location.pathname]);

  useEffect(() => {
    if (window.innerWidth > 1024) {
      setIsSidebarOpen(true);
    }
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 },
    );

    if (mainContentRef.current) {
      const elements =
        mainContentRef.current.querySelectorAll(".animate-on-scroll");
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, [activeMenuItem]);

  // for the notification

  const handleIncomingNotification = (notification) => {
    setMessages((prev) => [
      {
        message: notification.message,
        notificationTime:
          notification.notificationTime || notification.createdAt,
        ...notification,
      },
      ...prev,
    ]);

    setUnreadCount((count) => count + 1);
  };

  return (
    <div className="client-dashboard-container">
      {/* for notification service  */}
      <ClientNotification onNotification={handleIncomingNotification} />

      <TopNavbar
        showNotification={true}
        notificationConfig={{
          fetchNotificationsApi: fetchNotifications,
          fetchUnreadCountApi: fetchUnreadCount,
          markAllReadApi: markAllNotificationsAsRead,
          approveApi: approveRequest,
          rejectApi: rejectRequest,
          fetchUserApi: fetchUserDashboardData,
        }}
      />

      <Sidebar
        sidebarItems={sidebarItems}
        activeMenuItem={activeMenuItem}
        openSubMenu={openSubMenu}
        handleMenuClick={handleMenuClick}
        setActiveMenuItem={setActiveMenuItem}
        setTotalCandidates={setTotalCandidates}
        setFetchError={setFetchError}
        setLoginExpiredCandidates={setLoginExpiredCandidates}
        setLoginExpiredFetchError={setLoginExpiredFetchError}
        setIsLoadingLoginExpired={setIsLoadingLoginExpired}
        setBgvInProgressCandidates={setBgvInProgressCandidates}
        setBgvInProgressFetchError={setBgvInProgressFetchError}
        setIsLoadingBgvInProgress={setIsLoadingBgvInProgress}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />

      {!isSidebarOpen && (
        <button
          className="client-hamburger-btn"
          onClick={() => setIsSidebarOpen(true)}
        >
          <FaBars />
        </button>
      )}

      {isSidebarOpen && (
        <button
          className="client-close-sidebar-btn"
          onClick={() => setIsSidebarOpen(false)}
        >
          <FaTimes />
        </button>
      )}

      <main
        className={`dashboard-main ${isSidebarOpen ? "main-expanded" : ""}`}
        ref={mainContentRef}
      >
        <div className="dashboard-content">
          {activeMenuItem === "Dashboard" && !showReportPage && (
            <DashboardPage
              totalCandidates={totalCandidates}
              loginExpiredCandidates={loginExpiredCandidates}
              bgvInProgressCandidates={bgvInProgressCandidates}
              dashboardData={{
                totalCandidates: 220,
                pendingSubmission: 12,
                pendingCaseSubmission: 8,
                submittedVerification: 35,
                loginExpired: 2,
                chartData: [
                  { label: "Total Candidates", value: 42, color: "#6A1B9A" },
                  { label: "Pending Submission", value: 25, color: "#FFC107" },
                  {
                    label: "Submitted for Verification",
                    value: 13,
                    color: "#007BFF",
                  },
                  {
                    label: "Pending Case Submission",
                    value: 5,
                    color: "#FF5733",
                  },
                  {
                    label: "Ready for BGC",
                    value: 7,
                    color: "#28A745",
                  },
                  {
                    label: "Login Expired Candidates",
                    value: 3,
                    color: "#ec061d",
                  },
                  {
                    label: "Verification Completed",
                    value: 10,
                    color: "#17A2B8",
                  },
                ],
              }}
              setActiveMenuItem={setActiveMenuItem}
            />
          )}

          {activeMenuItem === "Profile" && !showReportPage && (
            <ProfileContainer />
          )}

          {activeMenuItem === "Add Candidate" && !showReportPage && (
            <AddCandidatePage
              candidateData={candidateData}
              handleCandidateChange={handleCandidateChange}
              handleCancelAddCandidate={handleCancelAddCandidate}
              setActiveMenuItem={setActiveMenuItem}
              submissionStatus={submissionStatus}
              setSubmissionStatus={setSubmissionStatus}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              redirectTimeout={redirectTimeout}
              setRedirectTimeout={setRedirectTimeout}
            />
          )}

          {activeMenuItem === "Pending Submission" && !showReportPage && (
            <PendingSubmissionPage />
          )}

          {activeMenuItem === "Login Expired Candidates" && !showReportPage && (
            <LoginExpiredCandidatesPage
              candidates={loginExpiredCandidates}
              isLoading={isLoadingLoginExpired}
              fetchError={loginExpiredFetchError}
            />
          )}

          

          {activeMenuItem === "Pending Case Submission" && !showReportPage && (
            <PendingCaseSubmissionPage onViewReportTwo={handleShowReportPage} />
          )}
          {activeMenuItem === "Ready for BGC" && !showReportPage && (
            <ReadyForBgcPage onViewReportTwo={handleShowReportPage} />
          )}

          {/* Pass handleShowReportPage to SubmittedVerificationPage */}
          {activeMenuItem === "Submitted Verification" && !showReportPage && (
            <SubmittedVerificationPage
              onViewReportTwo={handleShowReportPage}
              onViewReport={handleShowReportPage} // New prop
            />
          )}

          {activeMenuItem === "BGV In Progress Candidates" &&
            !showReportPage && (
              <BgvInProgressCandidatesPage
                onViewReportTwo={handleShowReportPage}
                candidates={bgvInProgressCandidates}
                isLoading={isLoadingBgvInProgress}
                fetchError={bgvInProgressFetchError}
              />
            )}

          {activeMenuItem === "BGV Completed Candidates" && !showReportPage && (
            <BgvCompletedCandidatesPage
              onViewReportTwo={handleShowReportPage}
              onViewFinalReport={handleShowFinalReportPage}
            />
          )}
{activeMenuItem === "Approve/Deny Requests" &&
  !showReportPage &&
  !showFinalReportPage && (
    <RequestManagementPage />
  )}

          {activeMenuItem === "Total Candidates" && !showReportPage && (
            <TotalCandidatesPage
              candidates={totalCandidates}
              fetchError={fetchError}
              onViewReportTwo={handleShowReportPage}
              onViewFinalReport={handleShowFinalReportPage}
            />
          )}

          {/* {activeMenuItem === "Payment" && !showReportPage && <PaymentPage />}

          {activeMenuItem === "PaymentSuccess" && <PaymentSuccess />}

          {activeMenuItem === "PaymentFailed" && <PaymentFailed />}

          {activeMenuItem === "Transaction History" && !showReportPage && (
            <TransactionHistory />
          )}

          {activeMenuItem === "Client Wallet" && !showReportPage && (
            <ClientWallet />
          )} */}
        </div>

        {/* {showReportPage && activeMenuItem === "Report" && (
          <button onClick={() => handleViewDetails(reportCandidateId)}>
            View Candidate Details
          </button>

        )} */}
        {activeMenuItem === "Final Report" && (
          <FinalReportPage
            candidateId={candidateId}
            onBack={handleBackFromFinalReport}
          />
        )}
      </main>
    </div>
  );
};

export default ClientDashboard;
